/* eslint-disable import/no-extraneous-dependencies */
import { createDriver as createAxiosDriver } from "@redux-requests/axios";
import { handleRequests } from "@redux-requests/core";
import axios from "axios";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import config from "../config";
import interceptors from "./interceptors";
import { changeCaseMiddleware } from "./middlewares";

export const INITIAL_STATE = {};

const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl.replace("{urlName}", window.location.hostname.split(".")[0])
});

export const configureStore = (preloadedState = INITIAL_STATE) => {
  const { requestsReducer, requestsMiddleware } = handleRequests({
    ...interceptors,
    driver: createAxiosDriver(axiosInstance),
    cache: true
  });

  if (config.appEnv === "dev") {
    requestsMiddleware.push(createLogger());
  }

  const composedEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose)(
    applyMiddleware(changeCaseMiddleware(), ...requestsMiddleware)
  );

  return createStore(
    combineReducers({ requests: requestsReducer }),
    preloadedState,
    composedEnhancers
  );
};
